import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common.js';
/**
 * Customers and jobs — the operational side of the object model.
 *
 * Read-first: these records are born from Housecall Pro sync and from
 * extraction, not from data-entry screens. The pages exist so the objects can
 * be seen, searched and connected; creation stays with the systems that
 * actually originate them.
 */
export const customerRowSchema = z.object({
    id: uuidSchema,
    displayName: z.string(),
    kind: z.enum(['residential', 'commercial', 'property_manager', 'builder', 'government']),
    primaryEmail: z.string().nullable(),
    primaryPhone: z.string().nullable(),
    billingCity: z.string().nullable(),
    isTaxExempt: z.boolean(),
    archivedAt: isoDateTimeSchema.nullable(),
});
export const customerDetailSchema = customerRowSchema.extend({
    legalName: z.string().nullable(),
    gstHstNumber: z.string().nullable(),
    billingProvince: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: isoDateTimeSchema,
});
export const jobStatusSchema = z.enum([
    'lead',
    'estimate',
    'scheduled',
    'in_progress',
    'completed',
    'invoiced',
    'closed',
    'cancelled',
]);
export const jobRowSchema = z.object({
    id: uuidSchema,
    jobNumber: z.string().nullable(),
    title: z.string(),
    status: jobStatusSchema,
    customerId: uuidSchema,
    customerName: z.string().nullable(),
    scheduledOn: z.string().nullable(),
    completedOn: z.string().nullable(),
    invoicedAmountMinor: z.string(),
    costAmountMinor: z.string(),
    isWarranty: z.boolean(),
});
export const jobDetailSchema = jobRowSchema.extend({
    description: z.string().nullable(),
    startedOn: z.string().nullable(),
    quotedAmountMinor: z.string().nullable(),
    parentJobId: uuidSchema.nullable(),
    createdAt: isoDateTimeSchema,
});
/** A unit of installed equipment — the machine on a customer's property. */
export const equipmentRowSchema = z.object({
    id: uuidSchema,
    label: z.string(),
    serialNumber: z.string().nullable(),
    category: z.string().nullable(),
    propertyAddress: z.string().nullable(),
    customerName: z.string().nullable(),
    installedOn: z.string().nullable(),
    partsWarrantyExpiresOn: z.string().nullable(),
    labourWarrantyExpiresOn: z.string().nullable(),
    status: z.enum(['active', 'removed', 'replaced', 'decommissioned']),
});
export const equipmentDetailSchema = equipmentRowSchema.extend({
    locationNote: z.string().nullable(),
    installedByJobId: uuidSchema.nullable(),
    manufacturer: z.string().nullable(),
    modelNumber: z.string().nullable(),
});
//# sourceMappingURL=parties.js.map